import "core-js/modules/es.array.concat.js";
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "class-contact"
};
import IframeContainer from '@/components/IframeContainer';
import { ref, computed, onMounted } from 'vue';
import { getEnvName, getHostName } from '@/util/env';
import { getBaseAppsUrl } from '@/util/util';
import useUserStore from '@/stores/modules/user';
import { storeToRefs } from 'pinia';
export default {
  __name: 'Contact',
  setup: function setup(__props) {
    var userStore = useUserStore();
    var _storeToRefs = storeToRefs(userStore),
      token = _storeToRefs.token;
    var pathData = computed(function () {
      // const envName = getEnvName()
      var hostName = getHostName();
      if (hostName) {
        var url = getBaseAppsUrl('chat-qa');
        return "".concat(url, "/contacts?token=").concat(token.value, "&pageType=teacherPad");
      } else {
        return 'http://192.168.1.49:7349/contacts?token=' + token.value + '&pageType=teacherPad';
      }
      //
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(IframeContainer), {
        src: pathData.value
      }, null, 8, ["src"])]);
    };
  }
};